import React from 'react';
import { observer } from 'mobx-react';
import { mdiMagnify } from '@mdi/js';
import Icon from '@mdi/react';
import './inputSearch.scss';

interface IInputSearchProps {
  name: string;
  searchString: string;
  placeholder: string;
  setSearchValue: React.ChangeEventHandler<HTMLInputElement>;
}

export const InputSearch = observer((props: IInputSearchProps) => {
  const { name, searchString, placeholder, setSearchValue } = props;

  return (
    <div className="input-search">
      <input
        className="usa-input"
        name={name}
        data-testid={name}
        type="text"
        aria-label={placeholder}
        placeholder={placeholder}
        onChange={setSearchValue}
        value={searchString}
      />
      <div className="input-search-icon">
        <Icon path={mdiMagnify} title="" size={1.5} className="text-primary" />
      </div>
    </div>
  );
});
